import { render } from "./ListGroup.vue?vue&type=template&id=c0aa4fa6"
import script from "./ListGroup.vue?vue&type=script&lang=js"
export * from "./ListGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__